/* eslint-disable no-nested-ternary */
import React from 'react'

import { Paragraph } from '@components/atoms'
import moment from 'moment'

import { ListHistorytyles } from './style'

const {
	Container,
	header,
	headerContainerDesc,
	Line,
	DismissIcon,
	VerticalLine,
	listContainer,
	RowList,
	timeContainer,
	iconContainer,
	CheckmarkIcon,
	ClockwiseIcon,
} = ListHistorytyles

export interface ListHistoryProps {
	id: number
	client_id: string
	action: 'clear_history' | 'mock_finished' | 'update'
	color: string
	icon: string
	description: string
	client_side_show: boolean
	created_at: string
}

type ListProps = {
	list: Array<ListHistoryProps>
	isProfile?: boolean
}

export const ListHistory = ({ list, isProfile = false }: ListProps) => {
	return (
		<Container isProfile={isProfile}>
			<div className={header()}>
				<div className={headerContainerDesc()}>
					<Paragraph
						paragraphType='p1'
						css={{
							color: '$neutral80',
							'@sm': {
								span: {
									display: 'none',
								},
							},
						}}
					>
						Data <span>| Horário</span>
					</Paragraph>

					<Paragraph
						paragraphType='p1'
						css={{
							color: '$neutral80',
							display: 'none',
							'@sm': {
								display: 'block',
							},
						}}
					>
						Horário
					</Paragraph>
					<Paragraph paragraphType='p1' css={{ color: '$neutral80' }}>
						Ação
					</Paragraph>
				</div>
				{/* 	<div>pesquisa</div> */}
			</div>
			{!isProfile && <Line />}

			<ul className={listContainer()}>
				{list.map(({ id, action, created_at }, index) => (
					<RowList key={id} status={action} isProfile={isProfile}>
						<div className={timeContainer()}>
							<Paragraph paragraphType='p1' css={{ color: '$neutral80' }}>
								{moment(created_at)
									.locale('pt-br')
									.format('DD MMM YY')
									.toUpperCase()}
							</Paragraph>

							<Paragraph paragraphType='p1' css={{ color: '$neutral80' }}>
								{moment(created_at)
									.locale('pt-br')
									.format('HH:mm')
									.toUpperCase()}
							</Paragraph>
						</div>

						<div className={iconContainer()}>
							{action === 'mock_finished' ? (
								<CheckmarkIcon />
							) : action === 'clear_history' ? (
								<DismissIcon />
							) : (
								<ClockwiseIcon />
							)}
							{index !== list.length - 1 && (
								<VerticalLine status={action} isProfile={isProfile} />
							)}
						</div>

						<Paragraph
							paragraphType='p1'
							css={{
								color: action === 'clear_history' ? '$red' : '$neutral160',
								paddingTop: '4px',
								fontWeight: '600',
								width: '100%',
								span: {
									color: '$neutral90',
									fontWeight: '400',
								},
							}}
						>
							{action === 'clear_history'
								? 'Histórico da dashboard apagado'
								: action === 'mock_finished'
								? 'Simulado finalizado'
								: 'Dashboard atualizada'}
							{(action === 'clear_history' || action === 'mock_finished') && (
								<span> com sucesso.</span>
							)}
						</Paragraph>
					</RowList>
				))}
			</ul>
		</Container>
	)
}
